export default __webpack_public_path__ + "static/media/TRUCK10.56d9bcbc.jpg";